import { CombinedVueInstance } from 'vue/types/vue';
import { Component, Mixins, Prop } from 'vue-property-decorator';
import { ROUTE_NAME } from '@/lib/constant';
import PopupComponent from '@/components/messageBox/popup';
import router from '@/router';

// 基因测试弹窗 9.3下线
@Component({
    name: 'GenePopup2',
    template: `<MyPopup v-model="value" :modal="true" class="gene-popup2" position="top">
        <div class="gene" :class="{gene4: type == 0, gene5: type == 1}">
            <div><i class="icon fr" @click="onClickCloseGenePopup">&#xe64b;</i></div>
            <div class="btn-wrap"><span class="btn" @click="onClickDetail" :data-growing-title="'gene_popup_2_' + type">了解一下</span></div>
        </div>
    </MyPopup>`,
})
export class GenePopup2 extends Mixins(PopupComponent) {
    /** 弹窗类型 */
    @Prop({ required: true, type: Number }) public type!: number;

    public onClickCloseGenePopup() {
        this.value = false;
    }

    public onClickDetail() {
        this.onClickCloseGenePopup();
        router.push({
            name: ROUTE_NAME.ACTIVITY_PAY_FINISHED,
            params: {
                activityId: '2',
            },
            query: {
                position: 'gene',
            },
        });
    }
}

export type GenePopupComponent2 = CombinedVueInstance<GenePopup2, object, object, object, Record<keyof object, any>>;
